import { LUDUM_QUICK_ASSIGN_TYPES, LUDUM_USER_ROLES } from '@/constants';

export const calendarQuickAssign = {
    namespaced: true,

    state: {
        selectedItems: []
    },

    getters: {
        selectedItems(state) {
            return state.selectedItems;
        },

        isEveryBodySelected(state) {
            return !_.isEmpty(_.find(state.selectedItems, ['type', LUDUM_QUICK_ASSIGN_TYPES.EVERYBODY]));
        },

        selectedAthletes(state, getters, rootState, rootGetters) {
            let athletes = [];

            _.each(getters.selectedItems, selectedItem => {
                if (selectedItem.type === LUDUM_QUICK_ASSIGN_TYPES.ATHLETE) {
                    Vue.set(athletes, athletes.length, selectedItem.id);
                }

                if (selectedItem.type === LUDUM_QUICK_ASSIGN_TYPES.SQUAD) {
                    _.each(selectedItem.squad_users.data, squadUser => {
                        const user = _.find(rootGetters['clubHelper/clubUsers'], ['id', squadUser.user_id]);
                        if (user && user.current_club_roles.data[0].id === LUDUM_USER_ROLES.ATHLETE) {
                            Vue.set(athletes, athletes.length, user.id);
                        }
                    });
                }
            });

            return _.uniq(athletes);
        },

        selectedCoaches(state, getters, rootState, rootGetters) {
            let coaches = [];

            _.each(getters.selectedItems, selectedItem => {
                if (selectedItem.type === LUDUM_QUICK_ASSIGN_TYPES.COACH) {
                    Vue.set(coaches, coaches.length, selectedItem.id);
                }

                if (selectedItem.type === LUDUM_QUICK_ASSIGN_TYPES.SQUAD) {
                    _.each(selectedItem.squad_users.data, squadUser => {
                        const user = _.find(rootGetters['clubHelper/clubUsers'], ['id', squadUser.user_id]);
                        if (
                            (user && user.current_club_roles.data[0].id === LUDUM_USER_ROLES.COACH) ||
                            (user && user.current_club_roles.data[0].id === LUDUM_USER_ROLES.HEAD_COACH)
                        ) {
                            Vue.set(coaches, coaches.length, squadUser.user_id);
                        }
                    });
                }
            });

            return _.uniq(coaches);
        }
    },

    mutations: {
        addSelectedItem(state, payload) {
            state.selectedItems.push(payload);
        },

        removeSelectedItem(state, payload) {
            const index = _.findIndex(
                state.selectedItems,
                selectedItem => payload.type === selectedItem.type && payload.id === selectedItem.id
            );

            state.selectedItems.splice(index, 1);
        },

        resetCalendarQuickAssignItems(state) {
            state.selectedItems = [];
        }
    }
};
